module.exports = __webpack_public_path__ + "static/img/138.3231e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/138.png
// module id = 8ARx
// module chunks = 0